import React from "react"
import {findDOMNode} from "react-dom"

import PopupMenuButton from "../../popup-menu-button/popup-menu-button"
import PopoverMenuCustomPopoverOptionButton from "./option-button"

type Props = {

    option              : Option
    menuParams?         : any
    disabled?           : boolean

    clickOutsideDelay?  : number

    onTogglePopover?    : func
}

// BAD IMPLEMENTEATION - chto to ne to tut

// the trigger's ignore-react-onclickoutside class also stops an open sibling popover from closing
// when another option of the same menu is clicked - so close it by hand
let openOption: {component: PopupMenuButton, menuNode: Node | null} | null = null

export default function PopoverMenuOptionWithCustomPopover(props: Props) {

    const onTogglePopover = (showPopover: boolean, component: PopupMenuButton) => {
        const prevOption = openOption

        if (showPopover) {
            openOption = {
                component   : component,
                menuNode    : findDOMNode(component)?.parentNode || null,
            }

            if (
                prevOption
                && prevOption.component !== component
                && prevOption.menuNode === openOption.menuNode
            ) {
                prevOption.component.hidePopover()
            }
        }
        else if (openOption?.component === component) {
            openOption = null
        }

        const callback = props.option.onTogglePopover || props.onTogglePopover
        callback?.(showPopover, component)
    }

    return (
        <PopupMenuButton
            // the trigger lives inside this menu; a click on it must not register as
            // an "outside click" for an ancestor popover (e.g. when this option sits
            // inside a submenu, which is a separate detached popover element)
            className                   = "ignore-react-onclickoutside"
            popoverClass                = {Classes("popover-option-custom", props.option.popoverClass)}
            // the popover's content is portaled to its own node under <body> (see Popover/Tether),
            // so it's never a DOM descendant of this trigger's own ignore-react-onclickoutside class -
            // without this, clicking inside the popped-out content (e.g. the Move project tree, or
            // the icon/color pickers) is treated as an "outside click" and closes the ancestor "More" popover
            popoverContentClass         = {Classes("ignore-react-onclickoutside", props.option.popoverContentClass)}
            popoverStyles               = {props.option.popoverStyles}
            popoverContentStyles        = {props.option.popoverContentStyles}
            attachment                  = "top left"
            targetAttachment            = "top right"
            offset                      = {props.option.popoverOffset || "0 0"}
            arrowPointOffset            = {props.option.popoverArrowPointOffset}
            attachmentType              = "vertical"
            arrowsVersion               = {2}
            outsideClickIgnoreClasses   = {props.option.outsideClickIgnoreClasses}
            btnComponent                = {PopoverMenuCustomPopoverOptionButton}
            menuComponent               = {props.option.menuComponent}
            menuParams                  = {{
                ...props.menuParams,
                option: props.option
            }}
            disabled                    = {props.disabled || props.option.disabled}
            clickOutsideDelay           = {props.clickOutsideDelay}
            onTogglePopover             = {onTogglePopover}
        />
    )
}

PopoverMenuOptionWithCustomPopover.defaultProps = {
    menuParams          : {},
    clickOutsideDelay   : 100
}
